export const scrollbarWrapperStyles = {
    flexGrow: 1,
    height: "100%",
    overflow: "hidden"
}

export const scrollbarStyles = {
    maxHeight: '100%',

    ".simplebar-track": {
        '& .simplebar-scrollbar': {
            width: 8,
            ml: 0.5,
            "&:before": {
                backgroundColor: "primary.main"
            },

            '&.simplebar-visible': {
                '&.:before': {
                    opacity: 1
                },
            },
        },
        '& .simplebar-mask': {
            zIndex: 'inherit'
        }
    }
}